export default "__VITE_ASSET__DKpHP7Ql__"